// extracted by mini-css-extract-plugin
export default {"button":"button_button__yn2Bn","default":"button_default__lt-u2","purple":"button_purple__8uR1E","gradient":"button_gradient__xKSIq"};